import styled, { css } from 'styled-components';

export default styled.div`
  z-index: 2;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  padding-right: 1.5rem;
  padding-left: 1.5rem;
  width: 100%;
  color: #fff;

  ${({ hasRelated }) => hasRelated ? css`
    padding-top: 2rem;
    padding-bottom: 3.75rem;
  ` : css`
    padding-top: 3rem;
    padding-bottom: 3rem;
  `}
`;
